import React from 'react'
import { theme } from '../../../theme'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const MobileHeader = () => {
  const history = useHistory()

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '5rem',
        padding: '0.5rem 1.5rem 0 1.5rem',
        backgroundColor: theme.dark.foreground
      }}
    >
      <div onClick={() => history.push('')}>
        <img src='/images/Logo.png' style={{ width: '9rem', cursor: 'pointer' }} />
      </div>
    </div>
  )
}

export default MobileHeader
